import {
  AfterViewInit,
  Component,
  ElementRef,
  Input,
  OnInit,
  Renderer2,
  ViewChild,
} from '@angular/core';
import { Router } from '@angular/router';

import { widgets as widgetTypes } from '@shared/constants';
import { IconColor, ImagePosition, Title, WidgetType } from '@shared/enums';
import { Widget, WidgetDetail } from '@shared/models';
import { TipFormDownloadService } from '@core/services';
import { readyOrWhenWidgets } from '@shared/utils';
import { UserContext } from '@core/models';
import { isThemedClient } from '@core/constants/program-code-constants';

const clickableWidgets = [
  WidgetType.Form1099Ready,
  WidgetType.Form1099Soon,
  WidgetType.FormW2Ready,
  WidgetType.FormW2Soon,
];

@Component({
  selector: 'sp-widget',
  templateUrl: './widget.component.html',
  styleUrls: ['./widget.component.scss'],
})
export class WidgetComponent implements OnInit, AfterViewInit {
  widget: Widget;
  title = Title;
  hasWidgetRoute: boolean;
  isTipsTypeWidget = false;
  isReadyOrWhenTypeWidget = false;
  isImagePositionMiddle = false;
  isImagePositionBottom = false;

  iconClass: { [key: string]: boolean };

  @Input() widgetDetail: WidgetDetail;
  @Input() evenVerticalGrid = true;
  @Input() userContext: UserContext;
  @Input() isMultipleCardPresent: boolean;

  @ViewChild('imageElement') imageElement: ElementRef;

  constructor(
    private tipFormDownloadService: TipFormDownloadService,
    private router: Router,
    private renderer: Renderer2
  ) {}

  ngOnInit(): void {
    this.widget = widgetTypes[this.widgetDetail.type];
    this.isTipsWidget();
    this.isReadyOrWhenWidget();
    this.buildDescriptions();
    this.hasWidgetRoute = this.hasRoute();

    const isThemed = isThemedClient(this.userContext?.programCode);
    this.iconClass = {
      themed: isThemed,
      isBlue: !isThemed && this.widget?.icon?.color === IconColor.Blue,
      isGreen: !isThemed && this.widget?.icon?.color === IconColor.Green,
    };
  }

  ngAfterViewInit(): void {
    if (!this.imageElement) return;

    const imageHeight = this.isMultipleCardPresent ? '150px' : '100%';
    this.renderer.setStyle(this.imageElement.nativeElement, '--image-height', imageHeight, 2);
  }

  downloadTipForm(formType: string): void {
    this.tipFormDownloadService.download(formType);
  }

  isReadyOrWhenWidget(): void {
    this.isReadyOrWhenTypeWidget = readyOrWhenWidgets.some(
      widget => widget === this.widgetDetail.type
    );
  }

  buildDescriptions(): void {
    //* show special description for facts widget otherwise the standard from template
    this.widget.description = this.widgetDetail.randomFact
      ? this.widgetDetail.randomFact
      : this.widget.description;
    //* position of the widget image is passed
    //* 3 cards - no images, 1 card - at the bottom, 2 - in the middle.
    this.isImagePositionMiddle = this.widgetDetail.showImage === ImagePosition.Middle;
    this.isImagePositionBottom = this.widgetDetail.showImage === ImagePosition.Bottom;
  }

  isTipsWidget(): void {
    this.isTipsTypeWidget = this.widgetDetail.type === WidgetType.TipsForm;
  }

  hasRoute(): boolean {
    return clickableWidgets.includes(this.widgetDetail.type);
  }

  getWidgetLink(): void {
    if (this.hasWidgetRoute) {
      const widgetRoute = this.widget.links[0];
      this.router.navigate([`${widgetRoute.route}`]);
    }
  }
}
